<div class="dialog">

  <div class="dialog-header">
    <span class="dialog-title">Manage utsav — {{ data.name }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <!-- INVENTORY TARGET -->
  <div class="section-title">Inventory target</div>
  <form [formGroup]="inventory" class="inventory-form" (ngSubmit)="saveInventory()">
    <div class="field">
      <span class="field-label">Total</span>
      <input type="number" class="text-box-active" formControlName="totalCapacity" />
    </div>
    <div class="field">
      <span class="field-label">Individual</span>
      <input type="number" class="text-box-active" formControlName="individualCapacity" />
    </div>
    <div class="field">
      <span class="field-label">Family</span>
      <input type="number" class="text-box-active" formControlName="familyCapacity" />
    </div>
    <div class="field">
      <span class="field-label">Bulk</span>
      <input type="number" class="text-box-active" formControlName="bulkCapacity" />
    </div>
    <button type="submit" class="ac-secondary-btn" [disabled]="isLoading">Save target</button>
  </form>

  <!-- STATS -->
  <div class="section-title">Target vs assigned</div>
  <div class="stats">
    <div class="stat">
      <span class="stat-label">Individual</span>
      <span class="stat-value">{{ capacity.assigned.individual }} / {{ capacity.target?.individualCapacity ?? 0 }}</span>
    </div>
    <div class="stat">
      <span class="stat-label">Family</span>
      <span class="stat-value">{{ capacity.assigned.family }} / {{ capacity.target?.familyCapacity ?? 0 }}</span>
    </div>
    <div class="stat">
      <span class="stat-label">Bulk</span>
      <span class="stat-value">{{ capacity.assigned.bulk }} / {{ capacity.target?.bulkCapacity ?? 0 }}</span>
    </div>
    <div class="stat">
      <span class="stat-label">Total</span>
      <span class="stat-value">{{ capacity.assigned.total }} / {{ capacity.target?.totalCapacity ?? 0 }}</span>
    </div>
  </div>

  <!-- ASSIGN PROPERTY -->
  <div class="section-title">Assign a property</div>
  <div class="assign-row">
    <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
      <mat-select
        panelClass="ac-select-panel"
        [disableOptionCentering]="true"
        [formControl]="propertyToAssign"
        placeholder="Select property"
      >
        @for(p of assignableProperties; track p.propertyId){
        <mat-option [value]="p.propertyId">{{ p.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <button type="button" class="ac-primary-btn" [disabled]="isLoading || !propertyToAssign.value" (click)="assignProperty()">Assign</button>
    <button type="button" class="ac-secondary-btn" [disabled]="isLoading" (click)="addNewProperty()">New property</button>
  </div>

  <!-- ASSIGNED -->
  <div class="section-title">Assigned properties</div>
  @if(properties.length > 0){
  <div class="assigned-list">
    @for(p of properties; track p.propertyId){
    <div class="assigned-property">
      <div class="assigned-property-head">
        <span>{{ p.name }} <span class="muted">({{ isActive(p.status) ? 'active' : 'inactive' }})</span></span>
        <div class="head-actions">
          <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="startAddRooms(p.propertyId)">
            Add rooms
          </button>
          <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="unassignProperty(p.propertyId)">
            Unassign property
          </button>
        </div>
      </div>

      @for(r of roomsForProperty(p.propertyId); track r.roomId){
      <div class="assigned-room">
        <span>Room {{ r.roomNumber }} · {{ r.roomType }} · cap {{ r.capacity }}</span>
        <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="unassignRoom(r.roomId)">Remove</button>
      </div>
      }

      @if(roomsForProperty(p.propertyId).length === 0){
      <div class="muted small">No rooms assigned from this property.</div>
      }

      <!-- add existing rooms of this property -->
      @if(isAddingRoomsFor(p.propertyId)){
      <div class="add-rooms-box">
        @if(addableRooms.length > 0){
        @for(r of addableRooms; track r.roomId){
        <label class="addable-room">
          <input type="checkbox" (change)="toggleRoomSelection(r.roomId, $event)" />
          <span>Room {{ r.roomNumber }} · {{ r.roomType }} · cap {{ r.capacity }}</span>
        </label>
        }
        <div class="add-rooms-actions">
          <button type="button" class="ac-secondary-small-btn" (click)="cancelAddRooms()">Cancel</button>
          <button type="button" class="ac-primary-btn" [disabled]="isLoading || selectedRoomIds.length === 0" (click)="confirmAddRooms()">Add selected</button>
        </div>
        } @else {
        <div class="muted small">No more active rooms to add from this property.</div>
        <button type="button" class="ac-secondary-small-btn" (click)="cancelAddRooms()">Close</button>
        }
      </div>
      }
    </div>
    }
  </div>
  } @else {
  <p class="muted">No properties assigned yet.</p>
  }


</div>

<app-loader [isLoading]="isLoading"></app-loader>
